export enum FeedType {
  LACTATION = 'LACTATION' as any,
  WEANING = 'WEANING' as any,
  FEMALE_STARTER = 'FEMALE_STARTER' as any,
  FINISHER = 'FINISHER' as any,
}
